"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const Button_1 = require("@Components/Buttons/Button");
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
const permissions_1 = require("@Const/permissions");
const RightsholderContactFormView_1 = require("@Components/RightsholderContact/RightsholderContactFormView");
const react_router_dom_1 = require("react-router-dom");
const PermissionCheck_1 = __importDefault(require("@Components/PermissionCheck"));
const mobx_react_1 = require("mobx-react");
const RightsholderContactInformationView = (props) => {
    const { preloaderStore, popupStore, contactStore, userStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [isPopupOpen, setIsPopupOpen] = (0, react_1.useState)(false);
    const rightsholderContact = contactStore.rightsholderContact;
    if (!rightsholderContact) {
        navigate(navigation_1.default.rightholder.maintenance.memberContacts(rightsholderStore.currentRightsholderId));
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const deleteRightsholderContact = () => {
        preloaderStore.openTransparentPreloader(true);
        contactStore
            .deleteRightsholderContact(rightsholderContact.ipId, rightsholderContact.id)
            .then(() => {
            navigate(navigation_1.default.rightholder.maintenance.memberContacts(rightsholderContact.ipId));
            popupStore.setAlertData('Your Contact was successfully deleted.', false);
        })
            .catch((error) => popupStore.setAlertData(error.message, true))
            .finally(() => preloaderStore.openTransparentPreloader(false));
    };
    const handleCancel = () => {
        setIsPopupOpen(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'view-contact-block' },
            react_1.default.createElement("div", { className: 'body-title' },
                react_1.default.createElement("h3", null, "View Contact")),
            react_1.default.createElement("div", { className: 'view-contact-border-block' },
                react_1.default.createElement(RightsholderContactFormView_1.RightsholderContactFormView, { rightsholderContact: rightsholderContact }),
                react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address], orIsInternal: true },
                    react_1.default.createElement("div", { className: 'buttons-block' },
                        react_1.default.createElement(Button_1.Button, { mainColor: false, type: 'primary', onClick: () => setIsPopupOpen(true) }, "Remove"),
                        react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', className: 'blue-border', onClick: () => props.setIsEditableState({
                                reload: false,
                                isEditable: true,
                            }) }, "Edit"))))),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: isPopupOpen, onClose: handleCancel },
            react_1.default.createElement(Popup_1.default, { onClose: handleCancel },
                react_1.default.createElement("div", { className: 'delete-contact-action' },
                    react_1.default.createElement(ConfirmationPopup_1.default, { title: "Are you sure you want to remove?", onCancel: handleCancel, onConfirm: deleteRightsholderContact, cancelButtonText: "Cancel", confirmButtonText: "Yes, I want to remove", confirmButtonClassName: "confirm-delete-contact-button", disabled: userStore.isInternal },
                        react_1.default.createElement("p", { className: 'sub-text' }, "Clicking remove will delete this contact.")))))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderContactInformationView);
